import LandingPage from 'components/Landing/LandingPage';

import { LANDING } from 'constants/EntryPoint';
import { LANDING_VIEW } from 'constants/ServerConstants';

import { FOOTER_TYPE_REQUEST_LANDING, FOOTER_TYPE_SEND_LANDING, LANG_COUNTRY } from './routeConstant';

const landing = [
    {
        path: [
            '/',
            '/send',
            '/send-money',
            '/alipay',
            '/ru/otpravit-dengi',
            '/uk/vidpravyty-hroshi',
            '/de/sende-geld',
            '/cs/poslat-penize',
            '/it/inviare-soldi',
            '/pl/wyslij-pieniadze',
            '/fr/envoyer-de-l-argent',
            '/ro/trimite-bani',
            '/tr/para-gondermek',
            '/es/enviar-dinero',
            '/zh/huikuan',
            '/in/kirim-uang',
            '/vi/chuyen-tien',
            '/uz/send-money',
            '/tl/send-money',
            '/pt/enviar-dinheiro',
            '/send/:from/:to',
            `/${LANG_COUNTRY}/send-money/:fromTo`,
            `/${LANG_COUNTRY}/otpravit-dengi/:fromTo`,
            `/${LANG_COUNTRY}/vidpravyty-hroshi/:fromTo`,
            `/${LANG_COUNTRY}/sende-geld/:fromTo`,
            `/${LANG_COUNTRY}/poslat-penize/:fromTo`,
            `/${LANG_COUNTRY}/inviare-soldi/:fromTo`,
            `/${LANG_COUNTRY}/wyslij-pieniadze/:fromTo`,
            `/${LANG_COUNTRY}/envoyer-de-l-argent/:fromTo`,
            `/${LANG_COUNTRY}/trimite-bani/:fromTo`,
            `/${LANG_COUNTRY}/para-gondermek/:fromTo`,
            `/${LANG_COUNTRY}/enviar-dinero/:fromTo`,
            `/${LANG_COUNTRY}/huikuan/:fromTo`,
            `/${LANG_COUNTRY}/kirim-uang/:fromTo`,
            `/${LANG_COUNTRY}/chuyen-tien/:fromTo`,
            `/${LANG_COUNTRY}/enviar-dinheiro/:fromTo`,
            `/${LANG_COUNTRY}/send`,
            `/${LANG_COUNTRY}`,
        ],
        exact: true,
        component: LandingPage,
        view: LANDING_VIEW,
        isAuthZone: false,
        stateOptions: {
            entryPoint: LANDING,
            isRequest: false,
            addCalculator: true,
            footerType: FOOTER_TYPE_SEND_LANDING,
            menuSection: 'personal',
        },
    },
    {
        path: [
            `/guatemala`,
            '/request',
            '/request-money',
            '/request/:from/:to',
            '/ru/zaprosit-dengi',
            '/uk/zaprosyty-hroshi',
            '/de/geld-erbitten',
            '/cs/pozadat-o-penize',
            '/it/richiesta-di-denaro',
            '/pl/popros-o-pieniadze',
            '/fr/demande-de-l-argent',
            '/ro/solicita-bani',
            '/tr/para-istemek',
            '/es/solicitar-una-transferencia-de-dinero',
            '/zh/shoukuan',
            '/in/minta-uang',
            '/vi/yeu-cau-chuyen-tien',
            '/pt/pedir-dinheiro',
            `/${LANG_COUNTRY}/request`,
            `/${LANG_COUNTRY}/request-money/:fromTo`,
            `/${LANG_COUNTRY}/zaprosit-dengi/:fromTo`,
            `/${LANG_COUNTRY}/zaprosyty-hroshi/:fromTo`,
            `/${LANG_COUNTRY}/geld-erbitten/:fromTo`,
            `/${LANG_COUNTRY}/pozadat-o-penize/:fromTo`,
            `/${LANG_COUNTRY}/richiesta-di-denaro/:fromTo`,
            `/${LANG_COUNTRY}/popros-o-pieniadze/:fromTo`,
            `/${LANG_COUNTRY}/demande-de-l-argent/:fromTo`,
            `/${LANG_COUNTRY}/solicita-bani/:fromTo`,
            `/${LANG_COUNTRY}/para-istemek/:fromTo`,
            `/${LANG_COUNTRY}/solicitar-una-transferencia-de-dinero/:fromTo`,
            `/${LANG_COUNTRY}/shoukuan/:fromTo`,
            `/${LANG_COUNTRY}/minta-uang/:fromTo`,
            `/${LANG_COUNTRY}/yeu-cau-chuyen-tien/:fromTo`,
            `/${LANG_COUNTRY}/pedir-dinheiro/:fromTo`,
        ],
        exact: true,
        component: LandingPage,
        view: LANDING_VIEW,
        isAuthZone: false,
        stateOptions: {
            entryPoint: LANDING,
            isRequest: true,
            addCalculator: true,
            footerType: FOOTER_TYPE_REQUEST_LANDING,
            menuSection: 'personal',
        },
    },
];

export default landing;
